


















































import { Component, Inject, Prop, Mixins } from "vue-property-decorator";
import { INote, INoteForm, INotesProviderMethods } from "@/models/notes";
import { ValidationObserver } from "vee-validate";
import HasValidation from "@/mixins/HasValidation";
import _ from "@/boot/lodash";

@Component
export default class AddEditNote extends Mixins(HasValidation) {
  public declare $refs: {
    note: HTMLFormElement;
    observer: InstanceType<typeof ValidationObserver>;
  };

  // Inject

  @Inject({ from: "notesProviderMethods" })
  public readonly $notesMethods!: INotesProviderMethods;

  // Props

  @Prop({ default: null })
  public noteId!: INote["id"];

  @Prop({ default: () => ({}) })
  public data!: INoteForm;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public inModalContext!: boolean;

  // Data

  public isProcessing = false;
  public formClone: INoteForm | any = {};
  public form: INoteForm = {
    pinned: false,
    note: ""
  };

  // Computed

  public get formIsValid() {
    if (this.noteId && _.isEqual(this.form, this.formClone)) return false;
    return !_.isEmpty(_.trim(this.form.note || ""));
  }

  public get formIsDisabled() {
    return this.isProcessing || !this.formIsValid || this.hasErrors;
  }

  public get formDiff() {
    return _.omitBy(this.form, (v, k) => {
      return this.formClone[k] === v;
    });
  }

  // Life-cycle methods

  public created() {
    if (this.noteId) {
      this.form = _.merge(this.form, this.data);
      this.formClone = _.clone(this.form);
    }
    if (this.inModalContext) {
      this.$nextTick(() => {
        this.$refs.note.$el.focus();
      });
    }
  }

  // Methods

  public validateBeforeSubmit() {
    if (!this.formIsValid || _.isEmpty(this.formDiff)) return;
    this.isProcessing = true;
    return this.validate()
      .then(result => {
        if (result) {
          this.form.note = this.form.note
            ? this.form.note.trim()
            : this.form.note;
          return this.noteId
            ? this.$notesMethods.updateNote(this.noteId, this.form)
            : this.$notesMethods.createNote(this.form);
        }
        throw this.$t("_sentence.form_is_not_valid");
      })
      .then(() => {
        this.form.note = "";
        this.$emit("close");
      })
      .catch(error => {
        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this
        });
      })
      .finally(() => {
        this.isProcessing = false;
      });
  }
}
